// extracted by css-extract-rspack-plugin
export default {"chip":"SuggestionChip_chip__RHnsE"};